var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMarkerViewed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 82,
    height: 52,
    viewBox: "0 0 82 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7853_65402)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_7853_65402",
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 4,
    width: 66,
    height: 36,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 8,
    y: 4,
    width: 66,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5C12.5817 5 9 8.58172 9 13V25C9 29.4183 12.5817 33 17 33H35.0714L40.8177 38.3632C41.2019 38.7218 41.7981 38.7218 42.1823 38.3632L47.9286 33H65C69.4183 33 73 29.4183 73 25V13C73 8.58172 69.4183 5 65 5H17Z"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5C12.5817 5 9 8.58172 9 13V25C9 29.4183 12.5817 33 17 33H35.0714L40.8177 38.3632C41.2019 38.7218 41.7981 38.7218 42.1823 38.3632L47.9286 33H65C69.4183 33 73 29.4183 73 25V13C73 8.58172 69.4183 5 65 5H17Z",
    fill: "#252D44"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5C12.5817 5 9 8.58172 9 13V25C9 29.4183 12.5817 33 17 33H35.0714L40.8177 38.3632C41.2019 38.7218 41.7981 38.7218 42.1823 38.3632L47.9286 33H65C69.4183 33 73 29.4183 73 25V13C73 8.58172 69.4183 5 65 5H17Z",
    fill: "white",
    fillOpacity: 0.18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.0714 33L35.7537 32.2689L35.4656 32H35.0714V33ZM40.8177 38.3632L40.1354 39.0942L40.8177 38.3632ZM42.1823 38.3632L42.8646 39.0942H42.8646L42.1823 38.3632ZM47.9286 33V32H47.5344L47.2463 32.2689L47.9286 33ZM10 13C10 9.13401 13.134 6 17 6V4C12.0294 4 8 8.02944 8 13H10ZM10 25V13H8V25H10ZM17 32C13.134 32 10 28.866 10 25H8C8 29.9706 12.0294 34 17 34V32ZM35.0714 32H17V34H35.0714V32ZM41.5 37.6321L35.7537 32.2689L34.3891 33.7311L40.1354 39.0942L41.5 37.6321ZM41.5 37.6321H41.5L40.1354 39.0942C40.9038 39.8114 42.0962 39.8114 42.8646 39.0942L41.5 37.6321ZM47.2463 32.2689L41.5 37.6321L42.8646 39.0942L48.6109 33.7311L47.2463 32.2689ZM65 32H47.9286V34H65V32ZM72 25C72 28.866 68.866 32 65 32V34C69.9706 34 74 29.9706 74 25H72ZM72 13V25H74V13H72ZM65 6C68.866 6 72 9.13401 72 13H74C74 8.02944 69.9706 4 65 4V6ZM17 6H65V4H17V6Z",
    fill: "white",
    mask: "url(#path-1-outside-1_7853_65402)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7853_65402",
    x: 0,
    y: 0,
    width: 82,
    height: 51.6328,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7853_65402"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7853_65402",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkerViewed);
export default __webpack_public_path__ + "static/media/marker-viewed.6a3a60fda7b7d2aea371d815b250c29a.svg";
export { ForwardRef as ReactComponent };